module.exports = __webpack_public_path__ + "static/img/8.4a8b9f4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/1/1/zh/8.png
// module id = yAiR
// module chunks = 0